import { NgModule } from '@angular/core';

import { KeyValuePipe } from '../../../startup/pipes/key-value.pipe';
import { SeatMapSpacingPipe } from '../../../startup/pipes/seat-map-spacing.pipe';

const pipes = [KeyValuePipe, SeatMapSpacingPipe];

@NgModule({
  declarations: pipes,
  exports: pipes
})
export class SharedPipesModule {}
